import { BaseSectionTitlePlugin } from './base';
import { SeeMoreLinkView, type SeeMoreLinkViewData } from '../views/SeeMoreLinkView/SeeMoreLinkView';

export type SeeMoreLinkPluginCustomData = Partial<SeeMoreLinkViewData>;

/**
 * SeeMoreLinkPlugin
 * @see {SeeMoreLinkView}
 * - SectionTitle 오른쪽에 '더보기' 링크를 추가하는 플러그인
 * - 기본 뷰 데이터: size 는 'xLarge', theme 는 'light' 로 설정
 */
export class SeeMoreLinkPlugin extends BaseSectionTitlePlugin<
  SeeMoreLinkViewData,
  SeeMoreLinkPluginCustomData
> {
  override ViewClass = SeeMoreLinkView;
  override default_view_data: SeeMoreLinkViewData = {
    size: 'xLarge',
    theme: 'light',
  };

  constructor(custom_view_data?: SeeMoreLinkPluginCustomData) {
    super();

    this.custom_view_data = custom_view_data;
  }

  override makeViewInstance(custom_view_data = this.custom_view_data) {
    return new this.ViewClass(this.makeViewData(custom_view_data));
  }
}
